module.exports = __webpack_public_path__ + "img/goal-sixteen-en.49be380b.png";